import { lazy } from 'react'
import { NVButton } from '@nv/basic-components'
import { useNVModal } from '@nv/components'
import DownloadFileIcon from '@nv/images/design/download-file-icon'
import { AdminVoterService } from '@nv/services'
import { useTranslation } from 'react-i18next'
import styles from './AdminElectionConfig.module.scss'
const SuccessDownloaded = lazy(() => import('@nv/lazy-loadable/lib/modals/SuccessDownloaded'))
const Downloading = lazy(() => import('@nv/lazy-loadable/lib/modals/Downloading'))

// TODO: revisit this page, right now it's very specific to PEI

export const AdminElectionConfig = () => {
  const { t } = useTranslation()
  const { NVModal: SuccessDownloadedModal, openModal: openSuccessDownloadedModal } = useNVModal()
  const { NVModal: DownloadingModal, openModal: openDownloadingModal, closeModal: closeDownloadingModal } = useNVModal()

  const getDowloadUrlVoters = async () => {
    openDownloadingModal()
    const res = await AdminVoterService.fetchEventConfigVoters()
    if (res?.success) {
      // @ts-ignore
      const href = URL.createObjectURL(res.data)
      const link = document.createElement('a')
      link.download = `voterlist`
      link.href = href
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      closeDownloadingModal()
      openSuccessDownloadedModal()
    }
  }
  const getDowloadUrlJurisdictions = async () => {
    openDownloadingModal()
    const res = await AdminVoterService.fetchEventConfigJurisdictions()
    if (res?.success) {
      // @ts-ignore
      const href = URL.createObjectURL(res.data)
      const link = document.createElement('a')
      link.download = `jurisdictions`
      link.href = href
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      closeDownloadingModal()
      openSuccessDownloadedModal()
    }
  }

  return (
    <>
      <DownloadingModal>
        <Downloading />
      </DownloadingModal>

      <SuccessDownloadedModal>
        <SuccessDownloaded />
      </SuccessDownloadedModal>

      <div className={styles['container-outer']}>
        <div className={styles['container']}>
          <div className={styles['footer']}>
            <div style={{ display: 'flex' }}>
              {t('admin.electionConfig.jurisdictions')}
              <NVButton
                variant='iconOnly'
                icon={<DownloadFileIcon />}
                onClick={() => getDowloadUrlJurisdictions()}
                ariaLabel={t('buttons.download')}
              />
            </div>
            <div style={{ display: 'flex' }}>
              {t('admin.electionConfig.electors')}
              <NVButton
                variant='iconOnly'
                icon={<DownloadFileIcon />}
                onClick={() => getDowloadUrlVoters()}
                ariaLabel={t('buttons.download')}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
